'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (stats) {
  if (!stats) return;
  var ckId = stats.ckId;
  var params = getParams(stats);

  // 防止日志丢失
  require('@ali/log').logClick(ckId, (0, _extends3.default)({}, params));
};

function getParams(stats) {
  var params = {};
  (0, _keys2.default)(stats).forEach(function (key) {
    if (key === 'ckId') return;
    params[key] = stats[key];
  });
  return params;
}